import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/ThankYou.css';

const ThankYou = () => {
  return (
    <div className="thank-you-page">
      <div className="container">
        <div className="thank-you-content">
          <i className="fas fa-check-circle"></i>
          <h1 className="text-gradient">Message Received!</h1>
          <p>
            Thank you for reaching out. Your message has been successfully transmitted. 
            I'll review it and get back to you within 24-48 hours.
          </p>
          <Link to="/" className="btn btn-primary">Return to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;